import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Loading from '../../../components/util/Loading/Loading';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

// Helper to construct linkExpired query parameters cleanly using URLSearchParams
const buildLinkExpiredUrl = email => {
  const params = new URLSearchParams();
  if (email) {
    params.set('email', email);
  }
  const queryString = params.toString();
  const path = '/linkExpired';
  return queryString ? `${path}?${queryString}` : path;
};

const MagicLinkValidationHandler = () => {
  const query = useQuery();
  const history = useHistory();
  const [_loading, setLoading] = useState(true);
  const [mobileSuccess, setMobileSuccess] = useState(false);
  const startedValidation = useRef(false);
  const rawEmail = query.get('email') || '';
  const email = rawEmail.split('?')[0].split('&')[0];

  const rawToken = query.get('token') || '';
  const token = rawToken.split('?')[0].split('&')[0];

  useEffect(() => {
    if (startedValidation.current) {
      return;
    }
    startedValidation.current = true;

    const validateToken = async () => {
      if (!token) {
        history.push(buildLinkExpiredUrl(email));
        return;
      }

      try {
        const params = new URLSearchParams();
        params.set('token', token);

        const response = await fetch(`/account/auth/magic-link/validate?${params.toString()}`, {
          credentials: 'include'
        });

        if (response.ok) {
          const data = await response.json();
          const { redirectUri } = data || {};

          if (redirectUri) {
            const isDeepLink =
              !redirectUri.startsWith('http://') && !redirectUri.startsWith('https://');

            if (isDeepLink) {
              window.location.href = redirectUri;
              setLoading(false);
              setMobileSuccess(true);
            } else {
              window.location.href = redirectUri;
            }
          } else {
            history.push(buildLinkExpiredUrl(email));
          }
        } else {
          // Failure (e.g. 401 Unauthorized / 400 Bad Request)
          let finalEmail = '';
          try {
            const errData = await response.json();
            if (errData && errData.email) {
              finalEmail = errData.email;
            }
          } catch (e) {
            // fallback if JSON parsing fails
            const responseUrl = response.url || '';
            const match = responseUrl.match(/[?&]email=([^&]+)/);
            if (match) {
              finalEmail = decodeURIComponent(match[1]);
            }
          }
          history.push(buildLinkExpiredUrl(finalEmail || email));
        }
      } catch (err) {
        console.error('Magic link validation failed:', err);
        history.push(buildLinkExpiredUrl(email));
      }
    };

    validateToken();
  }, [token, history, email]);

  if (mobileSuccess) {
    const isJdsp = window.location.hostname.includes('jdsports');
    const appName = isJdsp ? 'JD Sports' : 'Finish Line';
    return (
      <div
        className="container py-5 text-center"
        style={{ maxWidth: '480px', marginTop: '100px' }}
        data-testid="magic-link-mobile-success"
      >
        <h1 className="h2 text-uppercase mb-4">App Sign-In</h1>
        <p className="body2 text-muted mb-4">You have been successfully signed in!</p>
        <p className="body2 text-muted mb-5">
          If the <strong>{appName}</strong> app did not open automatically, please open the app on
          your device to access your account.
        </p>
        <button onClick={() => history.push('/login')} className="btn btn-secondary btn-block">
          Go to Sign In
        </button>
      </div>
    );
  }

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: '100vh' }}
      data-testid="magic-link-loading"
    >
      <Loading />
    </div>
  );
};

export default MagicLinkValidationHandler;
